<!-- Breadcrumb -->
<div class="pag-container">

  <app-campaign-3-breadcrumb #breadcrumbComponent [arrayBreadcrumbs]="breadcrumbs"
                             (onClickBreadcrumb)="breadcrumbClicked($event)" homeLink=""></app-campaign-3-breadcrumb>
                            
                            

  <!-- Bottoni gialli di lista azioni e creazione -->
  <div class="ui-g-12 d-flex justify-content-center">

    <div class="ui-g-7">
    </div>
    <div class="ui-g-5 footer-btn-container">
      <button data-testid="viewCampaignsList" class="btn-page-act btn-footer-l" (click)="onActionTable()">
        <i class="pi pi-eye margin-fit"></i> <span>{{ 'campaign.viewActionsList' | translate }}</span>
      </button>
      <button data-testid="createNewCampaign" class="btn-page-act" (click)="onOpenCreation()">
        <i class="pi pi-plus"></i> <span>{{ 'campaign.createNewCampaign' | translate }}</span>
      </button>
    </div>
  </div>
  <div class="ui-g-12">

    <div class="ui-g-6 " style="margin-top: 20px;">
        <div class="ui-g-8  d-flex align-items-center">
            <span class="title">{{ 'campaign.campaignList' | translate }}</span>
        </div>
        <div class="ui-g-4 d-flex align-items-center">
            <span class="title-span">{{ 'campaign.select_interval' | translate }}</span>
        </div>
    </div>

    <div class="ui-g-3">
        <span class="date-range">{{ 'campaign.from' | translate }}</span>
        <br>
        <p-calendar [(ngModel)]="startDate" dateFormat="dd/mm/yy" [showIcon]="true"></p-calendar>
    </div>
    <div class="ui-g-3">
        <span class="date-range">{{ 'campaign.to' | translate }}</span>
        <br>
        <p-calendar [(ngModel)]="endDate" dateFormat="dd/mm/yy" [showIcon]="true"></p-calendar>
    </div>
  </div>

  <div class="ui-g-12 prova">

    <!-- Attenzione il campo dei filtri della statu description manda in pasto il flag state quando in realtà dsovrebbe andarci l'idStatus (sempre nullo) -->
    <app-campaign-3-kontable #campaignlist *ngIf="readyTable" [columns]="[
    { field: 'name', title: 'campaign.name', bodyTemplate: nameTemplate },
    { field: 'start_date', title: 'campaign.start_date', bodyTemplate: startDateTemplate },
    { field: 'end_date', title: 'campaign.end_date', bodyTemplate: endDateTemplate },
    { field: 'budget', title: 'campaign.budget', filterType: textFilter, bodyTemplate: budgetTemplate },
    { field: 'budget_type_id', title: 'campaign.budget_type_id', filterType: budgetList, bodyTemplate: budgetTypeTemplate },
    { field: 'campaign_type_id', title: 'campaign.campaign_type_id', filterType: selectFilter, filterOptions: { values: campaignType }, bodyTemplate: campaignTemplate },
    { field: 'code', title: 'campaign.code', filterType: noFilter, bodyTemplate: actionTemplate },
    { field: 'campaign_status_id', title: 'campaign.campaign_status_id', filterType: selectFilter, filterOptions: { values: statusList }, bodyTemplate: statusTemplate }
    ]" [service]="testService" [paginationType]="paginationType" [showRecoverButton]="false" [showInfoButton]="false"
                             [showAddButton]="false" [showDeleteButton]="false" [showDetailsButton]="false" [showEditButton]="false"
                             [filterBySingleColumn]="false" [additionalRowCommands]="actions" [showGlobalFilter]="true"
                             [expandTable]="true" [fetchActionListAsap]="true" [subjectToLoad]="pageSubject" [filterStartDate]="startDate"
                             [filterEndDate]="endDate" (onClearFilters)="clearDateFields()">


      <ng-template #nameTemplate let-row>
        <span [ngClass]="checkExpiredCampaign(row)">{{ row.name }}</span>
      </ng-template>

      <ng-template #startDateTemplate let-row>
                <span [ngClass]="checkExpiredCampaign(row)"> {{
                    row.start_date |
                      date:srvCalendar.pcalendarTranslate.dateFormatFilter
                  }}</span>
      </ng-template>

      <ng-template #endDateTemplate let-row>
                <span [ngClass]="checkExpiredCampaign(row)">{{
                    row.end_date |
                      date:srvCalendar.pcalendarTranslate.dateFormatFilter
                  }}</span>
      </ng-template>

      <ng-template #budgetTemplate let-row>
                <span [ngClass]="checkExpiredCampaign(row)">{{
                    row.budget.toLocaleString('it-IT', {
                      style: 'currency',
                      currency: 'EUR'
                    })
                  }}</span>
      </ng-template>

      <ng-template #budgetTypeTemplate let-row>
        <span [ngClass]="checkExpiredCampaign(row)">{{ getBudgetType(row.budget_type_id) }}</span>
      </ng-template>

      <ng-template #actionTemplate let-row>
        <span class="center-number" [ngClass]="checkExpiredCampaign(row)">{{ getNumberOfAction(row) }}</span>
      </ng-template>

      <ng-template #campaignTemplate let-row>
        <span [ngClass]="checkExpiredCampaign(row)">{{ getCampaignDescription(row.campaign_type_id) }}</span>
      </ng-template>

      <ng-template #statusTemplate let-row>
        <span class="status-dot" [ngClass]="getStatusDotClass(row)"></span>
        <span [ngClass]="checkExpiredCampaign(row)"> {{ getStatusDescription(row) }}</span>
      </ng-template>

      <ng-template #actions let-row>

        <div class="d-flex ">
          <button data-testid-generic="editCampaign" [attr.data-testid]="'editCampaign' + row.id" pTooltip="{{ 'common.edit' | translate }}" class="roundedButton row-buttom-margin"
                  [ngClass]="{'roundedButton': !onCheckEndCampaign(row), 'disabled-button': onCheckEndCampaign(row)}"
                  (click)="onOpenEdit(row.id)" [disabled]="onCheckEndCampaign(row)">
            <i class="pi pi-pencil icon-size"></i>
          </button>
          <button data-testid-generic="campaignActions" [attr.data-testid]="'campaignActions' + row.id" pTooltip="{{ 'common.actions' | translate }}" class="roundedButton"
                  (click)="toggleMenu(row.id)">
            <i class="pi pi-ellipsis-h icon-size"></i>
          </button>

        </div>

        <div class="dropdown-menu" *ngIf="showMenu && row.id == currentOpenedRow">

          <button data-testid-generic="deleteCampaign" 
            [disabled]="checkAlreadyDeleted(row)"
             [attr.data-testid]="'deleteCampaign' + row.id"
              class="dropdown-item"
               (click)="deleteCampaign(row)"
               [ngClass]="{'notPermitted': checkAlreadyDeleted(row)}">{{ 'common.deleteNew' | translate }}</button>


        </div>


      </ng-template>

    </app-campaign-3-kontable>
  </div>

</div>
<div *ngIf="showPopupCreate">

  <p-dialog class="myDialog"
            header="{{ 'campaign.create_campaign' | translate }}"
            [(visible)]="showPopupCreate"
            [modal]="true">

    <app-new-campaign-3 [budgetTypeList]="budgetList"
                        [campaignTypeList]="campaignType"
                        [statusList]="statusList"
                        (refreshPage)="refreshAfterEdit()"
                        (closeCreationPopup)="onClosePopupCreation()">
    </app-new-campaign-3>

  </p-dialog>

</div>


<div *ngIf="showPopupEdit">

  <p-dialog class="myDialog"
  header="{{ 'campaign.edit_campaign' | translate }}"
            [(visible)]="showPopupEdit"
            [modal]="true">

    <app-edit-campaign-3 [campaignTypeList]="campaignType"
                         (refreshPage)="refreshAfterEdit()"
                         [budgetTypeList]="budgetList"
                         [campaign]="singleCampaign"
                         [campaignStartDate]="singleCampaignStartDate"
                         [campaignEndDate]="singleCampaignEndDate"
                         (closeEditPopup)="onClosePopupEdit()"
                         [statusList]="statusList">
    </app-edit-campaign-3>

  </p-dialog>
</div>

<p-dialog
header="{{ 'campaign.confirm_delete' | translate }}"
  [(visible)]="displayDeleteDialog"
  [modal]="true"
  [closable]="false"
  class="custom-dialog">

  <div>{{ 'campaign.confirm_delete_message' | translate }} {{ campaignToDelete?.name }}?</div>


  <div class="custom-footer">
    <button type="button" pButton label="{{ 'common.cancel' | translate }}" (click)="closePopupDelete()" icon="pi pi-times"></button>
    <button type="button" pButton label="{{ 'common.confirm' | translate }}"  (click)="onDefinitiveDelete(campaignToDelete)" icon="pi pi-check" style="margin-left: .25em"></button>
  </div>
</p-dialog>




<footer>
    <!--     <div class="ui-g-12 d-flex justify-content-center">

        <div class="ui-g-7">
        </div>
        <div class="ui-g-5 footer-btn-container">
            <button class="btn-page-act btn-footer-l" (click)="onActionTable()">
                <i class="pi pi-eye margin-fit"></i> <span>Visualizza la lista azioni</span>
            </button>
            <button class="btn-page-act" (click)="onOpenCreation()">
                <i class="pi pi-plus"></i> <span> Crea una nuova campagna </span>
            </button>
        </div>
    </div> -->

</footer>



// WEBPACK FOOTER //
// ./src/app/views/campaign-3/campaign-list/campaign-list3.component.html